import React from 'react';

import Button from '@components/Button';
import { SubscriberCouncilPartner } from '@utils/backend-api/partners';
import { isExternalURL } from '@utils/url_validations';

interface SubscriberCouncilCardProps {
  partner: SubscriberCouncilPartner;
}

const SubscriberCouncilCard = ({ partner }: SubscriberCouncilCardProps) => {
  const { id, name, tagline, targetLink } = partner;
  const externalLinkAttributes = isExternalURL(targetLink, window.location)
    ? { target: '_blank', rel: 'sponsored' }
    : {};

  return (
    <div className="mb-8 border-0 border-l border-solid border-[#c4c6ce] py-3 pl-12 font-['Meta',Georgia,sans-serif] text-[14px] text-zinc-800">
      <Button
        href={targetLink}
        variant="link"
        trackClick
        trackingProps={{
          name: 'csc_card',
          identifier: id.toString(),
        }}
        {...externalLinkAttributes}
      >
        {name}: {tagline}
      </Button>
    </div>
  );
};

export default SubscriberCouncilCard;
